/**
 * Privacy Policy Page Module
 */

import router from './router.js';

class PrivacyPage {
  constructor() {
    this.container = null;
  }

  render() {
    const app = document.getElementById('app');
    const hero = document.getElementById('hero');
    if (app) app.style.display = 'none';
    if (hero) hero.style.display = 'none';

    if (!this.container) {
      this.container = document.createElement('div');
      this.container.id = 'privacy-page';
      this.container.className = 'static-page';
      this.setupEventListeners();
    }

    this.container.innerHTML = `
      <div class="static-page-header">
        <button class="back-btn" id="back-btn" aria-label="Go back">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M19 12H5M12 19l-7-7 7-7"/>
          </svg>
          Back
        </button>
        <h1 class="static-page-title">Privacy Policy</h1>
      </div>

      <div class="static-page-content">
        <p class="static-page-updated">Last updated: February 9, 2026</p>

        <section class="policy-section">
          <h2>1. Introduction</h2>
          <p>Welcome to Anilora ("we", "our", "us"). We are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website.</p>
        </section>

        <section class="policy-section">
          <h2>2. Information We Collect</h2>
          <h3>Authentication Data</h3>
          <p>We use anonymous authentication to enable features like liking, rating, and downloading wallpapers. No personal information (name, email, or password) is required to use our platform.</p>
          <h3>Usage Data</h3>
          <p>We collect information about your interactions with our platform, including:</p>
          <ul>
            <li>Wallpapers you like and rate</li>
            <li>Download history</li>
            <li>Search queries and category preferences</li>
          </ul>
        </section>

        <section class="policy-section">
          <h2>3. Cookies & Local Storage</h2>
          <p>We use local storage to maintain your authentication session (powered by Supabase) and your theme preference. We do not use tracking cookies for advertising purposes.</p>
        </section>

        <section class="policy-section">
          <h2>4. Third-Party Services</h2>
          <p>We use the following third-party services to operate our platform:</p>
          <ul>
            <li><strong>Supabase</strong> &mdash; Authentication and database services</li>
            <li><strong>ImageKit</strong> &mdash; Image CDN for optimized wallpaper delivery</li>
            <li><strong>Cloudflare</strong> &mdash; Hosting, CDN, and DDoS protection</li>
            <li><strong>Firebase</strong> &mdash; Contact form submission processing</li>
          </ul>
          <p>Each of these services has its own privacy policy governing how they handle data.</p>
        </section>

        <section class="policy-section">
          <h2>5. Data Retention</h2>
          <p>We retain your data for as long as needed to provide our services. Anonymous session data may be periodically cleaned up.</p>
        </section>

        <section class="policy-section">
          <h2>6. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access the personal data we hold about you</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Withdraw consent for data processing</li>
          </ul>
          <p>To exercise any of these rights, please contact us using the information below.</p>
        </section>

        <section class="policy-section">
          <h2>7. Data Security</h2>
          <p>We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction.</p>
        </section>

        <section class="policy-section">
          <h2>8. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. We will notify you of any changes by updating the "Last updated" date at the top of this page.</p>
        </section>

        <section class="policy-section">
          <h2>9. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy or our data practices, please <a href="/contact" class="static-page-link" data-route="/contact">contact us</a>.</p>
        </section>
      </div>
    `;

    if (!document.body.contains(this.container)) {
      const footer = document.querySelector('.footer');
      if (footer) {
        document.body.insertBefore(this.container, footer);
      } else {
        document.body.appendChild(this.container);
      }
    }

    this.container.style.display = 'block';
    window.scrollTo({ top: 0, behavior: 'instant' });
  }

  setupEventListeners() {
    this.container.addEventListener('click', (e) => {
      if (e.target.closest('#back-btn')) {
        router.back();
        return;
      }

      const routeLink = e.target.closest('[data-route]');
      if (routeLink) {
        e.preventDefault();
        router.navigate(routeLink.dataset.route);
      }
    });
  }

  hide() {
    if (this.container) {
      this.container.style.display = 'none';
    }
    const app = document.getElementById('app');
    const hero = document.getElementById('hero');
    if (app) app.style.display = 'block';
    if (hero) hero.style.display = 'block';
  }
}

export default new PrivacyPage();
